import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import PI_img from "../img/PI.jfif";
import Back from "../img/Home_back.png";
function People_item_0 (){
    return (
      <Category_wrapper>
          <Item_wrapper>
          <Span_div>
            <Content_span>
            Principal Investigator
            </Content_span>
          </Span_div>
          <Content_Wrapper>
          <Left_div>
            <Img_div src={PI_img}/>
            <Content_div>
                <Item_span_title>
                Chang Wook Jeong MD, PhD 
                </Item_span_title>
                <Item_content>
                Associate Professor<br/>
                Department of Urology<br/>
                Seoul National University Hospital & Seoul National University College of Medicine<br/> 
                <br/>
                Deputy head<br/>
                Office of Hospital Information Seoul National University Hospital <br/>
                <br/>
                Department Head<br/>
                Department of Data Science Research<br/>
                SIMTRI (SNUH Innovative Medical Technology Research Institute)<br/>
                </Item_content>
            </Content_div>
          </Left_div>
          <Right_content>
            <UL>
            <Title_span_T>Education</Title_span_T>
              <LI>
                <IN_Span>
                  <Point_span/>Seoul National University College of Medicine (MD, 2001)
                </IN_Span>
                <IN_Span>     
                <Point_span/>Seoul National University College of Medicine <br/>(Master in Medicine, 2005)
                </IN_Span>
                <IN_Span>    
                <Point_span/>Seoul National University College of Medicine (PhD, 2011)
                </IN_Span>
              </LI>
              <Title_span_T>Career</Title_span_T>
              <LI>
              <IN_Span>
              <Point_span/>Associate Professor, Department of Urology, Seoul National University College of Medicine, Seoul, Korea (2020-Present)
              </IN_Span>
              <IN_Span>
              <Point_span/>Visiting scholar, University of California, San Francisco, CA, USA (2018-2019)
              </IN_Span>
              <IN_Span>
              <Point_span/>Visiting scholar, University of Southern California, Los Angeles, CA, USA (2016)
              </IN_Span>
              <IN_Span>    
              <Point_span/>Associate Professor, Department of Urology, Seoul National University Hospital, Seoul, Korea (2015-Present)
              </IN_Span>
              <IN_Span>
              <Point_span/>Assistant Professor, Department of Urology, Seoul National University Hospital, Seoul, Korea (2013-2015)
              </IN_Span>
              <IN_Span>
              <Point_span/>Assistant Professor, Department of Urology, Seoul National University Bungdang Hospital, Seongnam, Korea (2011-2013)
              </IN_Span>
              </LI>
              <Title_span_T>Experience</Title_span_T>
              <LI>
              
              <IN_Span>
              <Point_span/>Department Head, Department of Data Science Research, SIMTRI (SNUH Innovative Medical Technology Research Institute), Seoul, Korea (2020-Present)
              </IN_Span>
              <IN_Span>
              <Point_span/>Deputy head, Office of Hospital Information, Seoul National University Hospital, Seoul, Korea (2020-Present)
              </IN_Span>
              <IN_Span>
              <Point_span/>Director of Clinical Data Warehouse, Office of Hospital Information, Seoul National University Hospital, Seoul, Korea (2013-2018)
              </IN_Span>
              <IN_Span>
              <Point_span/>Vice Director, Medical Device Innovation Center, Seoul National University Hospital, Seoul, Korea (2013-2018)
              </IN_Span>
              <IN_Span>
              <Point_span/>Board Member, Medical Device Innovation Center, Seoul National University Bundang Hospital, Seongnam, Korea (2011-2013)
              </IN_Span>
              <IN_Span>
              <Point_span/>              
              Director of Clinical Data Warehouse, Medical Information Center, Seoul National University Bundang Hospital, Seongnam, Korea (2012-2013)
              </IN_Span>
              </LI>
            </UL>
          </Right_content>
          </Content_Wrapper>
        </Item_wrapper>
      </Category_wrapper>
    )
  }
  const Title_span_T = styled.span`
  font-weight: bold;
  color: #414141;
  font-size : 25px;
  font-family: "Table_title";        

`
 const  Content_Wrapper = styled.div`
 padding : 40px 0px;

 `
  const IN_Span = styled.span`
  display: block;
  margin : 0;
  padding : 10px 20px;
  font-size : 20px;
  line-height : 30px;
  color : #212121;
  background:#FFFFFF;

`
  const UL = styled.ul`
  margin : 20px 0 ;
`
const LI = styled.li`
  margin : 25px 0;
  line-height : 35px;
  color : #707070;
  text-indent : -9px;
  box-shadow: 5px 3px 5px rgba(70, 70, 70, 0.2);
  font-family: "Table_content";        
`
const Point_span = styled.span`        
    background :#32A4FF;
    width : 5px; 
    height : 5px; 
    line-height : 25px;
    display : inline-block; 
    border-radius : 100%;
    vertical-align : middle;
    margin : 0 10px;
`
  const Item_content = styled.div`
    font-size : 16px;
    text-align : left;
    padding : 10px 5px ;
    line-height: 26px;
    font-family: "People_content";        
  `

  const Item_span_title = styled.div`
    font-weight : bold;
    font-size : 20px;
    font-family: "PI_name";        
    text-align : left;
    padding : 0 5px ;
    line-height : 25px;
  `  
  const Img_div =styled.img`
    width  : 520px;
    height :390px;
    vertical-align : top;
  `
  const Content_div =styled.div`
    width : 300px;
    display : inline-block;
    vertical-align : top;
    margin-left : 30px;
  `
  const Left_div = styled.div`
    width : 850px; 
    display : inline-block;
    vertical-align : top;
  `
  const Right_content = styled.div`
    width : 880px; 
    display : inline-block;
  `
  const Item_wrapper = styled.div`
  width : 880px;
  margin : 70px auto;
  `
  const Category_wrapper = styled.div`
    width : 1200px;
    margin : 0px auto;
    padding : 50px 0;
    font-family: "En";        
    background : url(${Back});    
    background-size : 1700px;
    background-position-x : 1252px;

   
    `
  const Content_span = styled.span`
  font-family: "Title";        
    display : block;
    font-size : 35px; 
    font-weight : bold; 
    width : 700px;
    box-sizing : border-box  ;
  `
  const Span_div = styled.div`
    width : 550px;
    text-align : left; 
  `
  
  export default People_item_0;